import React, { useState } from "react";

import { Button, Col, Form, Input, Row, Select } from "antd";
import { useNavigate } from "react-router-dom";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import ConfirmationBox from "../../../../components/common/ConfirmationBox";
import Footer from "../../../../components/common/Footer";
import EditEelectronicSignature from "../../../../components/common/EditElectronicSignature";

import { RiArrowUpSLine, RiArrowDownSLine } from "react-icons/ri";
import { MdAddCircle } from "react-icons/md";
import { pdfTemplates } from "../../../../data/leases";

import "./PDFFormTemplates.css";

function PDFFormTemplates() {
  const [collapse, setCollapse] = useState(false);
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const [templates, setTemplates] = useState(pdfTemplates);
  const [template, setTemplate] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleDeleteClick = (item) => {
    setTemplate(item);
    setIsConfirmationBoxOpen(true);
  };

  const deletePDFTemplate = (id) => {
    const newArr = templates.filter((item) => {
      return item.id !== Number(id);
    });
    setTemplates(newArr);
    setIsConfirmationBoxOpen(false);
  };

  const AddNewPDFfromTemplate = () => {
    navigate("/leasing/leases/pdf-form-templates/add_new_pdf");
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const onCancelModal = () => {
    setIsModalOpen(false);
  };

  const PDFFormTemplatesRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        "Lease Templates",
        "1",
        "",
        "",
        "/leasing/leases/lease-templates"
      ),
      RightBarMethod(
        <span onClick={showModal}>Edit Electronic Signature</span>,
        "2",
        "",
        "",
        ""
      ),
    ]),
    RightBarMethod(
      "Help Topics",
      "t2",
      <i className="fa-solid fa-circle-question"></i>,
      [RightBarMethod("PDF Form Templates", "3", "", "", "/leasing/leases/pdf-form-templates")]
    ),
  ];

  return (
    <>
      <div className="page-container">
        <div className="main-container pdf-outer-container">
          <PageHeading heading="PDF Form Templates" />
          <button className="add-new-btn" onClick={AddNewPDFfromTemplate}>
            <MdAddCircle size={18} />
            <span>Add New PDF Form Template</span>
          </button>
          <div className="pdf-form-templates">
            <Row gutter={[0, 24]}>
              <Col span={24}>
                <Form layout="vertical">
                  <Row gutter={[16, 0]}>
                    <Col span={10}>
                      <Form.Item label="Search Templates">
                        <Input placeholder="Type to search" />
                      </Form.Item>
                    </Col>
                    <Col span={10}>
                      <Form.Item label="Template Type">
                        <Select
                          placeholder="Select"
                          options={[
                            { value: "Resident Form" },
                            { value: "Lease/Addendum" },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item label=" ">
                        <Button>Clear Filters</Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Col>
              {templates.map((item, index) => {
                return (
                  <Col span={24} key={index} className="outer-row">
                    <Row gutter={[0, 16]} className="inner-row">
                      <Col span={24}>
                        <Row>
                          <Col span={12}>
                            <span className="onclick-text">
                              {item.templateName}
                            </span>
                          </Col>
                          <Col span={5}>
                            <span>{item.templateType}</span>
                          </Col>
                          <Col span={6}>
                            <span className="silver-text">Created On</span>
                            <p>{item.createdOn}</p>
                          </Col>
                          <Col span={1} onClick={() => setCollapse(!collapse)}>
                            {collapse ? (
                              <RiArrowUpSLine size={18} />
                            ) : (
                              <RiArrowDownSLine size={18} />
                            )}
                          </Col>
                        </Row>
                      </Col>
                      {collapse ? (
                        <Col span={24}>
                          <Row gutter={[16, 0]}>
                            <Col>
                              <span className="onclick-text">Edit</span>
                            </Col>
                            <Col>
                              <span className="onclick-text">Duplicate</span>
                            </Col>
                            <Col>
                              <span className="onclick-text">Replace PDF</span>
                            </Col>
                            <Col>
                              <span
                                className="onclick-red-text"
                                onClick={() => handleDeleteClick(item)}
                              >
                                Delete
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </div>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={PDFFormTemplatesRightBar} />
      </div>
      {isConfirmationBoxOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
          <h2>Please Confirm</h2>
          <p>Do you want to delete {template?.templateName}?</p>
          <div className="action-buttons">
            <button
              className="red"
              onClick={() => deletePDFTemplate(template?.id)}
            >
              Delete
            </button>
            <button
              className="cancel-btn"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
      <EditEelectronicSignature
        showModal={isModalOpen}
        cancelModal={onCancelModal}
      />
    </>
  );
}

export default PDFFormTemplates;
